import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "../config";

export const mtnTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.demo,
  logoUrl: "https://cdn.nemuru.com/assets/logos/mtn-logo.svg",
  palette: {
    primary: {
      main: "#FFCB05",
      contrastText: "#212529",
    },
    secondary: {
      main: "#212529",
      light: "#212529",
      contrastText: "#fff",
    },
    text: {
      title: "#212529",
      primary: "#212529",
      secondary: "#757575",
    },
    warning: {
      main: "#E9AE00",
      contrastText: "#212529",
      light: "rgba(255, 202, 40, 0.15)",
    },
    info: {
      main: "#36a3f7",
      contrastText: "#ffffff",
      light: "#E1F1FD",
    },
    success: {
      main: "#4dd970",
      contrastText: "#ffffff",
      light: "rgba(73,217,106,0.15)",
    },
    error: {
      main: "#ef5957",
      contrastText: "#ffffff",
      light: "rgba(239,87,87,0.15)",
    },
    dark: {
      main: "#fff5cb",
      accent: "#AD8B00",
      contrastText: "#000",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#1c8135",
      approved: "#033d12",
      analysing: "#00697c",
      sent: "#0041a5",
      cancelled: "#b6b5b2",
      denied: "#f1595c",
    },
    grey: {
      50: "#fafafa",
      100: "#f7f7f7",
      200: "#f4f4f4",
      300: "#f0f0f0",
      400: "#e0e0e0",
      500: "#c2c2c2",
      600: "#9e9e9e",
      700: "#757575",
      800: "#505050",
      900: "#2d2d2d",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#f0f0f0",
  customBorderRadius: {
    button: 25,
    paper: 8,
    chip: 100,
  },
  typography: {
    fontFamily: "Helvetica, Arial, sans-serif",
  },
};
